
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-power" })
export default class IconPower extends Vue {
  sData: string = require("@icon/feather/power.svg");
}
